import imageMeta from "@/lib/imageMeta.json";

const CLOUDINARY =
  /^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(v\d+\/.+)$/;

/** Adds f_auto (AVIF/WebP), q_auto and a max width to Cloudinary URLs.
 *  Other URLs, SVGs and URLs that already carry a transformation are untouched. */
export function optimizeImageUrl(src, maxWidth = 1200) {
  if (!src || typeof src !== "string" || /\.svg($|\?)/i.test(src)) return src;
  const m = src.match(CLOUDINARY);
  return m ? `${m[1]}f_auto,q_auto,c_limit,w_${maxWidth}/${m[2]}` : src;
}

/**
 * Drop-in replacement for <img>:
 *  - optimised delivery through Cloudinary (modern formats, capped width)
 *  - intrinsic width/height from the build-time metadata (prevents layout shift)
 *  - lazy + async decoding by default; pass `priority` for above-the-fold images
 *  - `maxWidth` = widest rendition to request, in px (use ~2x the CSS width)
 */
export default function OptImg({
  src,
  maxWidth = 1200,
  priority = false,
  loading,
  width,
  height,
  alt = "",
  ...rest
}) {
  const meta = imageMeta[src];
  return (
    <img
      src={optimizeImageUrl(src, maxWidth)}
      alt={alt}
      width={width ?? meta?.[0]}
      height={height ?? meta?.[1]}
      loading={priority ? "eager" : loading ?? "lazy"}
      decoding="async"
      {...(priority ? { fetchPriority: "high" } : {})}
      {...rest}
    />
  );
}
